// components/common/Button.tsx

import { cn } from "@/lib/utils";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "success" | "danger";
  size?: "sm" | "md";
}

export function Button({
  variant = "primary",
  size = "md",
  className,
  ...props
}: ButtonProps) {
  const variants = {
    primary: "border-[var(--accent)] bg-[var(--accent)] text-[var(--text-inverse)] hover:bg-[var(--accent-hover)]",
    secondary: "border-[var(--border)] bg-[var(--surface)] text-[var(--text)] hover:bg-[var(--surface-muted)]",
    success: "border-[var(--success)] bg-[var(--success)] text-[var(--text-inverse)]",
    danger: "border-[var(--danger)] bg-[var(--danger)] text-[var(--text-inverse)]",
  };

  const sizes = {
    sm: "h-9 px-3 text-xs",
    md: "h-10 px-4 text-sm",
  };

  return (
    <button
      className={cn(
        "ui-focus inline-flex shrink-0 items-center justify-center gap-2 rounded-[var(--radius-sm)] border font-semibold transition disabled:opacity-60",
        sizes[size],
        variants[variant],
        className
      )}
      {...props}
    />
  );
}
